// extracted by mini-css-extract-plugin
export default {"palletDimensions":"PalletInfoSection_palletDimensions__SOnr-","palletPrice":"PalletInfoSection_palletPrice__J6D5y"};